import TeamsIntegrationSetup from "./TeamsIntegration";

export default TeamsIntegrationSetup;
